// ExpertMarketplace.jsx
import React, { useState, useMemo } from 'react';
import {
  Crown,
  Star,
  Clock,
  Briefcase,
  Users,
  MessageCircle,
  Calendar,
  CheckCircle,
  ArrowRight,
  Search,
  Filter,
  X,
  User,
  Mail,
  Phone,
  MapPin,
  Award,
  Zap,
  Shield,
  Sparkles,
  ChevronDown,
  ChevronUp
} from 'lucide-react';
import './Expertteam.css';

const ExpertMarketplace = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedExpertise, setSelectedExpertise] = useState('All');
  const [visibleCount, setVisibleCount] = useState(6);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [showBookingPopup, setShowBookingPopup] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const allExperts = [
    {
      id: 1,
      name: "Ravi Kumar",
      role: "CAD & DFM Expert",
      experience: "15 yrs",
      rate: "₹500",
      rating: 4.9,
      reviews: 127,
      avatar: "RK",
      expertise: ["CAD Modeling", "DFM Analysis", "3D Printing", "Product Design"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Visakhapatnam",
      about: "Expert in CAD modeling and Design for Manufacturing with 15+ years of experience in automotive and aerospace industries."
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Product Design Engineer",
      experience: "10 yrs",
      rate: "₹650",
      rating: 4.8,
      reviews: 98,
      avatar: "PS",
      expertise: ["Product Design", "Prototyping", "3D Modeling", "UX Design"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Vijayawada",
      about: "Product design specialist with expertise in creating user-centric designs and rapid prototyping."
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "Manufacturing Specialist",
      experience: "12 yrs",
      rate: "₹750",
      rating: 4.7,
      reviews: 85,
      avatar: "AP",
      expertise: ["Manufacturing", "Process Optimization", "Quality Control", "Lean Six Sigma"],
      availability: "Busy",
      verified: true,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Tirupati",
      about: "Manufacturing expert with deep knowledge in process optimization and quality management systems."
    },
    {
      id: 4,
      name: "Sneha Reddy",
      role: "Materials Engineer",
      experience: "8 yrs",
      rate: "₹550",
      rating: 4.9,
      reviews: 156,
      avatar: "SR",
      expertise: ["Materials Science", "Composites", "Testing", "R&D"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Kurnool",
      about: "Materials engineer specializing in advanced composites and materials testing for aerospace applications."
    },
    {
      id: 5,
      name: "Vikram Singh",
      role: "Electronics Expert",
      experience: "14 yrs",
      rate: "₹800",
      rating: 4.6,
      reviews: 72,
      avatar: "VS",
      expertise: ["PCB Design", "Embedded Systems", "IoT", "Circuit Design"],
      availability: "Busy",
      verified: true,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Guntur",
      about: "Electronics expert with extensive experience in PCB design, embedded systems, and IoT solutions."
    },
    {
      id: 6,
      name: "Deepa Nair",
      role: "Biomedical Engineer",
      experience: "9 yrs",
      rate: "₹600",
      rating: 4.8,
      reviews: 112,
      avatar: "DN",
      expertise: ["Biomedical", "Medical Devices", "Regulatory", "Quality"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Nellore",
      about: "Biomedical engineer specializing in medical device development and regulatory compliance."
    },
    {
      id: 7,
      name: "Arjun Mehta",
      role: "Robotics Expert",
      experience: "11 yrs",
      rate: "₹900",
      rating: 4.9,
      reviews: 203,
      avatar: "AM",
      expertise: ["Robotics", "Automation", "AI", "Machine Learning"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Visakhapatnam",
      about: "Robotics and automation expert with expertise in AI-powered solutions for manufacturing."
    },
    {
      id: 8,
      name: "Meera Krishnan",
      role: "Sustainability Expert",
      experience: "10 yrs",
      rate: "₹550",
      rating: 4.7,
      reviews: 94,
      avatar: "MK",
      expertise: ["Sustainability", "Green Manufacturing", "Circular Economy", "ESG"],
      availability: "Busy",
      verified: true,
      image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&crop=center&auto=format&q=80",
      location: "Vijayawada",
      about: "Sustainability consultant helping businesses transition to green manufacturing practices."
    }
  ];

  const expertiseOptions = ["All", "CAD Modeling", "DFM Analysis", "3D Printing", "Product Design", 
    "Manufacturing", "Process Optimization", "Materials Science", "PCB Design", "Embedded Systems", 
    "Robotics", "Automation", "Sustainability"];

  const filteredExperts = useMemo(() => {
    let filtered = allExperts;
    
    // Search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(expert =>
        expert.name.toLowerCase().includes(query) ||
        expert.role.toLowerCase().includes(query) ||
        expert.expertise.some(skill => skill.toLowerCase().includes(query)) ||
        expert.location.toLowerCase().includes(query)
      );
    }
    
    // Expertise filter
    if (selectedExpertise !== 'All') {
      filtered = filtered.filter(expert =>
        expert.expertise.includes(selectedExpertise)
      );
    }
    
    return filtered;
  }, [searchQuery, selectedExpertise]);

  const visibleExperts = filteredExperts.slice(0, visibleCount);
  const hasMore = visibleCount < filteredExperts.length;

  const handleViewMore = () => {
    setVisibleCount(prev => Math.min(prev + 6, filteredExperts.length));
  };

  const handleBook = (expert) => {
    setSelectedExpert(expert);
    setShowBookingPopup(true);
    document.body.style.overflow = 'hidden';
  };

  const closeBookingPopup = () => {
    setShowBookingPopup(false);
    setSelectedExpert(null);
    document.body.style.overflow = 'unset';
  };

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    alert(`✅ Booking request sent to ${selectedExpert.name}!`);
    closeBookingPopup();
  };

  return (
    <>
      <section className="expert-marketplace">
        <div className="expert-marketplace-container">
          {/* Header */}
          <div className="expert-marketplace-header">
            <div className="expert-marketplace-badge">
              <Crown size={16} className="expert-badge-icon" />
              <span>Expert Network</span>
            </div>
            <h2 className="expert-marketplace-title">
              Connect with <span>Industry Experts</span>
            </h2>
            <p className="expert-marketplace-desc">
              Find the right expertise to bring your innovation to life
            </p>
          </div>

          {/* Search & Filter */}
          <div className="expert-marketplace-toolbar">
            <div className="expert-search-wrapper">
              <Search size={18} className="expert-search-icon" />
              <input
                type="text"
                placeholder="Search experts by name, expertise, or location..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="expert-search-input"
              />
              {searchQuery && (
                <button
                  className="expert-search-clear"
                  onClick={() => setSearchQuery('')}
                >
                  <X size={16} />
                </button>
              )}
            </div>
            <button
              className="expert-filter-toggle"
              onClick={() => setShowFilter(!showFilter)}
            >
              <Filter size={18} />
              <span>Filters</span>
              {selectedExpertise !== 'All' && (
                <span className="expert-filter-count">1</span>
              )}
              {showFilter ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          </div>

          {/* Filter Options */}
          {showFilter && (
            <div className="expert-filter-options">
              <div className="expert-filter-header">
                <span className="expert-filter-title">Filter by Expertise</span>
                {selectedExpertise !== 'All' && (
                  <button
                    className="expert-filter-clear"
                    onClick={() => setSelectedExpertise('All')}
                  >
                    <X size={14} />
                    Clear
                  </button>
                )}
              </div>
              <div className="expert-filter-tags">
                {expertiseOptions.map((option) => (
                  <button
                    key={option}
                    className={`expert-filter-tag ${selectedExpertise === option ? 'active' : ''}`}
                    onClick={() => setSelectedExpertise(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          )}

          

          {/* Expert Cards Grid */}
          <div className="expert-cards-grid">
            {visibleExperts.map((expert) => (
              <div key={expert.id} className="expert-card">
                <div className="expert-card-image">
                  <img
                    src={expert.image}
                    alt={expert.name}
                    className="expert-card-img"
                    loading="lazy"
                  />
                  {expert.verified && (
                    <div className="expert-verified-badge">
                      <CheckCircle size={14} />
                      <span>Verified</span>
                    </div>
                  )}
                  <div className={`expert-availability ${expert.availability === 'Available Now' ? 'available' : 'busy'}`}>
                    {expert.availability}
                  </div>
                </div>

                <div className="expert-card-content">
                  <div className="expert-card-header">
                    <div>
                      <h4 className="expert-card-name">{expert.name}</h4>
                      <p className="expert-card-role">{expert.role}</p>
                    </div>
                    <div className="expert-card-rating">
                      <Star size={14} fill="#f59e0b" stroke="#f59e0b" />
                      <span>{expert.rating}</span>
                    </div>
                  </div>

                  <div className="expert-card-details">
                    <div className="expert-card-detail">
                      <Clock size={14} />
                      <span>{expert.experience}</span>
                    </div>
                    <div className="expert-card-detail">
                      <Briefcase size={14} />
                      <span>{expert.rate} / 30 min</span>
                    </div>
                    <div className="expert-card-detail">
                      <Users size={14} />
                      <span>{expert.reviews} reviews</span>
                    </div>
                  </div>

                  <div className="expert-card-expertise">
                    {expert.expertise.slice(0, 3).map((skill, idx) => (
                      <span key={idx} className="expert-skill-tag">{skill}</span>
                    ))}
                    {expert.expertise.length > 3 && (
                      <span className="expert-skill-tag more">+{expert.expertise.length - 3}</span>
                    )}
                  </div>

                  <div className="expert-card-actions">
                    <button 
                      className="expert-connect-btn"
                      onClick={() => window.location.href = `mailto:expert@apic.in?subject=Connect with ${expert.name}`}
                    >
                      <MessageCircle size={16} />
                      <span>Connect</span>
                    </button>
                    <button 
                      className="expert-book-btn"
                      onClick={() => handleBook(expert)}
                    >
                      <Calendar size={16} />
                      <span>Book</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No Results */}
          {filteredExperts.length === 0 && (
            <div className="expert-no-results">
              <div className="expert-no-results-icon">
                <Search size={32} />
              </div>
              <h4 className="expert-no-results-title">No experts found</h4>
              <p className="expert-no-results-desc">
                Try adjusting your search or filter criteria
              </p>
              <button
                className="expert-no-results-btn"
                onClick={() => { setSearchQuery(''); setSelectedExpertise('All'); }}
              >
                Clear all filters
              </button>
            </div>
          )}

          {/* View More Button */}
          {filteredExperts.length > 6 && (
            <div className="expert-view-more">
              <button 
                className="expert-view-more-btn"
                onClick={handleViewMore}
                disabled={!hasMore}
              >
                {hasMore ? (
                  <>
                    <span>View More Experts</span>
                    <ArrowRight size={18} />
                  </>
                ) : (
                  <span>Showing all {filteredExperts.length} experts</span>
                )}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Booking Popup */}
      {showBookingPopup && selectedExpert && (
        <div className="expert-booking-overlay" onClick={closeBookingPopup}>
          <div className="expert-booking-popup" onClick={(e) => e.stopPropagation()}>
            <button className="expert-booking-close" onClick={closeBookingPopup}>
              <X size={24} />
            </button>
            
            <div className="expert-booking-header">
              <div className="expert-booking-expert-info">
                <img
                  src={selectedExpert.image}
                  alt={selectedExpert.name}
                  className="expert-booking-expert-image"
                />
                <div>
                  <h3 className="expert-booking-expert-name">{selectedExpert.name}</h3>
                  <p className="expert-booking-expert-role">{selectedExpert.role}</p>
                  <div className="expert-booking-expert-rating">
                    <Star size={14} fill="#f59e0b" stroke="#f59e0b" />
                    <span>{selectedExpert.rating}</span>
                    <span className="expert-booking-expert-reviews">({selectedExpert.reviews} reviews)</span>
                  </div>
                </div>
              </div>
              <div className="expert-booking-rate">
                <span className="expert-booking-rate-value">{selectedExpert.rate}</span>
                <span className="expert-booking-rate-label">/ 30 min</span>
              </div>
            </div>

            <form className="expert-booking-form" onSubmit={handleBookingSubmit}>
              <div className="expert-booking-form-group">
                <label className="expert-booking-label">
                  <User size={16} />
                  Full Name
                </label>
                <input
                  type="text"
                  className="expert-booking-input"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="expert-booking-form-group">
                <label className="expert-booking-label">
                  <Mail size={16} />
                  Email Address
                </label>
                <input
                  type="email"
                  className="expert-booking-input"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="expert-booking-form-group">
                <label className="expert-booking-label">
                  <Phone size={16} />
                  Phone Number
                </label>
                <input
                  type="tel"
                  className="expert-booking-input"
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <div className="expert-booking-form-group">
                <label className="expert-booking-label">
                  <Calendar size={16} />
                  Preferred Date & Time
                </label>
                <input
                  type="datetime-local"
                  className="expert-booking-input"
                  required
                />
              </div>

              <div className="expert-booking-form-group">
                <label className="expert-booking-label">
                  <MessageCircle size={16} />
                  Message (Optional)
                </label>
                <textarea
                  className="expert-booking-textarea"
                  placeholder="Briefly describe what you need help with..."
                  rows="3"
                ></textarea>
              </div>

              <div className="expert-booking-summary">
                <div className="expert-booking-summary-item">
                  <span>Consultation Fee</span>
                  <span>{selectedExpert.rate}</span>
                </div>
                <div className="expert-booking-summary-item">
                  <span>Duration</span>
                  <span>30 minutes</span>
                </div>
                <div className="expert-booking-summary-total">
                  <span>Total</span>
                  <span>{selectedExpert.rate}</span>
                </div>
              </div>

              <button type="submit" className="expert-booking-submit">
                <Calendar size={18} />
                <span>Confirm Booking</span>
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpertMarketplace;